export default __webpack_public_path__ + "static/media/greater2.7847a1a4.svg";